import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {scraperRegister} from "../../services/scraperRegister";

class ModalLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            url: null
        };
    };

    componentWillMount() {}

    componentDidMount() {
        this.setState({url: this.props.url, new: this.props.new});
    }

    _close(){
        this.props.setModal(false);
    }

    _set(){
        if(this.state.new){
            let scraper_object = {
                images: [],
                slogans: [],
                additional_information: {
                    broker: {},
                    facts: {
                        area_sqft: null,
                        bathrooms: null,
                        bedrooms: null,
                        completion_status: null,
                        currency: null,
                        listing_platform: null,
                        listing_type: null,
                        price: null,
                        type: null
                    },
                    url: null
                }
            };
            scraperRegister.set(scraper_object);
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login?new=true");
        }else{
            let string = this.state.url?('?url='+this.state.url):'';
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login" + string);
        }
    }

    _renderText(item) {
        return langRegister.get("modal-login", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          {
                              salesChannelRegister.get('name')!=='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon.svg")}/>
                          }
                          {
                              salesChannelRegister.get('name')==='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon_yl.svg")}/>
                          }
                          <div>
                              <div className={Styles.overlayModalTitle}>
                                  {this._renderText("item_1")}
                              </div>
                              <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.overlayModalText}>
                                  {this._renderText("item_4")}
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => this._close()}
                                   className={Styles.overlayModalButtonsItemButton}>
                                  {this._renderText("item_2")}
                              </div>
                          </div>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div style={salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: '#E65032'}:{}} onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  {this._renderText("item_3")}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalLogin;


// WEBPACK FOOTER //
// ./src/components/modal-login/component.js